import {
  THEME_COOKIE_LEGACY,
  THEME_INIT_SCRIPT,
  THEME_STORAGE_KEY,
  applyTheme,
  readThemePreference,
  type ThemePreference,
} from '@/lib/theme'

/** @deprecated Use THEME_STORAGE_KEY from lib/theme */
export const DOCS_THEME_STORAGE_KEY = THEME_STORAGE_KEY

/** @deprecated Use THEME_COOKIE from lib/theme — still written for SSR hydration */
export const DOCS_THEME_COOKIE = THEME_COOKIE_LEGACY

export type DocsTheme = ThemePreference

export function resolveDocsTheme(): DocsTheme {
  return readThemePreference()
}

export function applyDocsTheme(theme: DocsTheme): void {
  applyTheme(theme)
}

/** Site-wide preference must survive leaving /docs. */
export function clearDocsThemeClasses(): void {
  /* no-op */
}

export const DOCS_THEME_INIT_SCRIPT = THEME_INIT_SCRIPT
